import React from 'react';
import ourbenefit from '../assets/images/our-benefit-img.jpg';
import ourbenefit1 from '../assets/images/icon-our-benefit-1.svg';
import ourbenefit2 from '../assets/images/icon-our-benefit-2.svg';
import ourbenefit3 from '../assets/images/icon-our-benefit-3.svg';
import ourbenefit4 from '../assets/images/icon-our-benefit-4.svg';
import whatwedoimg from '../assets/images/what-we-do-img-1.jpg';
import whatwedoimg2 from '../assets/images/what-we-do-img-2.jpg';

function Acceptdomesticpayment() {
  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2">
                  Server Infrastructure Support
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Domestic Payment Optimization Section */}
      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="our-benefit-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2">
                    Optimizing Your Existing <span>Server Infrastructure</span>
                  </h2>
                  <p>
                    At TechInfintech, we specialize in supporting businesses that already have servers or cloud infrastructure in place but are facing real-world challenges like frequent downtime, slow performance, security vulnerabilities, or technical glitches. We don’t replace your infrastructure — we fix and enhance the one you already use, helping you achieve smoother, more reliable system performance.                  </p>
                </div>

                <div className="our-benefit-btn">
                  <a href="/contact" className="btn-default">
                    Get Expert Support
                  </a>
                </div>

                <div className="our-benefit-img">
                  <figure>
                    <img src={ourbenefit} alt="Domestic Payment Optimization" />
                  </figure>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="our-benefit-box">
                <div className="our-benefit-list">

                  <div className="our-benefit-item">
                    <div className="icon-box">
                      <img src={ourbenefit1} alt="UPI Optimization" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Server Infrastructure Optimization</h3>
                      <p>
                       Fix common server crashes, downtime issues, resource overloads, and response delays. We analyze system behavior, optimize configurations, and improve overall stability for a seamless user experience.
                      </p>
                    </div>
                  </div>

                  <div className="our-benefit-item">
                    <div className="icon-box">
                      <img src={ourbenefit2} alt="Card Payment Support" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Cloud Environment Optimization</h3>
                      <p>
                        Reduce high latency, resolve configuration errors, fix recurring hosting failures, and stabilize deployment flows for better performance.
                      </p>
                    </div>
                  </div>

                  <div className="our-benefit-item">
                    <div className="icon-box">
                      <img src={ourbenefit3} alt="Netbanking Support" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Network Troubleshooting</h3>
                      <p>
                        Solve routing problems, monitor bandwidth bottlenecks, and improve connectivity reliability across your infrastructure.
                      </p>
                    </div>
                  </div>

                  <div className="our-benefit-item">
                    <div className="icon-box">
                      <img src={ourbenefit4} alt="Wallet Support" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>Database Performance Optimization</h3>
                      <p>
                        Eliminate query slowdowns, fix integration glitches, and ensure seamless database operations for your applications and users.
                      </p>
                    </div>
                  </div>

                </div>

                <div className="our-benefit-get-quote">
                  <p>
                    Facing issues with your current server or cloud setup? Let our experts help you fix it.
                    <a href="/contact"> Contact us today</a>
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Security & Compliance Section */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2">
                    Server Security & <span>Compliance Support</span>
                  </h2>
                  <p>
                    We help businesses using existing servers or cloud infrastructure stay secure, manage security incidents effectively, reduce cyber risks, and maintain full compliance — minimizing operational and reputational damage.
                  </p>
                </div>

                <div className="what-we-do-list">
                  <ul>
                    <li>Detailed security audit & vulnerability assessment</li>
                    <li>Threat investigation & incident response support</li>
                    <li>Backup, recovery & system restoration troubleshooting</li>
                    <li>API, server configuration, and integration error fixing</li>
                  </ul>
                </div>

                <div className="what-we-do-btn">
                  <a href="/contact" className="btn-default">
                    Get Secure Support Now
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="what-we-do-images">
                <div className="what-do-we-img-1">
                  <figure>
                    <img src={whatwedoimg} alt="Payment Security Guidance" />
                  </figure>
                </div>

                <div className="what-do-we-img-2">
                  <figure>
                    <img src={whatwedoimg2} alt="Compliance & Risk Management" />
                  </figure>
                </div>

                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span>5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of hands-on infrastructure & IT support experience</p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Performance Improvement Section */}
      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="our-benefit-img">
                <figure>
                  <img src={ourbenefit} alt="Transaction Performance Optimization" />
                </figure>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2">
                    Boosting Server Speed & <span>Success Rates</span>
                  </h2>
                  <p>
                    We fine-tune your existing server and cloud configuration to deliver faster response times, reduced downtime, optimized resource allocation, and significantly higher system reliability — without changing your provider.
                  </p>
                </div>

                <div className="what-we-do-btn">
                  <a href="/contact" className="btn-default">
                    Improve Performance Now
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Reporting Section */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="what-we-do-content">
                <div className="section-title">
                  <h2 className="text-anime-style-2">
                    Clear Reporting & <span>Business Insights</span>
                  </h2>
                  <p>
                    We simplify complex settlement reports, transaction logs, and performance data — giving you clear visibility into what's working, what's failing, and how to grow your business confidently.
                  </p>
                </div>

                <div className="what-we-do-btn">
                  <a href="/contact" className="btn-default">
                    Get Better Insights
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="what-we-do-images">
                <div className="what-do-we-img-1">
                  <figure>
                    <img src={whatwedoimg} alt="Advanced Reporting Support" />
                  </figure>
                </div>

                <div className="what-do-we-img-2">
                  <figure>
                    <img src={whatwedoimg2} alt="Payment Analytics & Visibility" />
                  </figure>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </>
  );
}

export default Acceptdomesticpayment;